export interface IDropdownOption {
    text?: string;
    value?: string;
    isSelected?: boolean;
    isHeader?: boolean;
    name?: string;
    key?: string;
    isDisabled?: boolean;
}

export interface IDropdown {
    label?: string;
    name?: string;
    image?: string;
    options?: IDropdownOption[];
    className?: string;
    // isMultiSelect?: boolean;
    // msSelectedTextTemplate?: string;
    // msAllSelectedTextTemplate?: string;
    // msMinimumOneSelected?: boolean;
    // msSelectAllBtnText?: string;
    // msUnSelectAllBtnText?: string;
    // msShowToggleSelectionBtn?: boolean;
    isDisabled?: boolean;
}

export interface IDropdownEventType {
    ddName: string;
    selectedValues: Array<IDropdownOption>;
    selectedOptions: Array<IDropdownOption>;
}

export class DropdownOption implements IDropdownOption {
    text: string;
    value: string;
    isSelected?: boolean;
    isHeader?: boolean;
    name?: string;
    key?: string;
    isDisabled?: boolean;

    constructor(dropdownOption: IDropdownOption) {
        this.text = dropdownOption.text;
        this.value = dropdownOption.value;

        if (dropdownOption.isSelected !== null && dropdownOption.isSelected !== undefined) {
            this.isSelected = dropdownOption.isSelected;
        }
        if (dropdownOption.isHeader) {
            this.isHeader = dropdownOption.isHeader;
        }
        if (dropdownOption.name) {
            this.name = dropdownOption.name;
        }
        if (dropdownOption.key) {
            this.key = dropdownOption.key;
        }
        if (dropdownOption.isDisabled) {
            this.isDisabled = dropdownOption.isDisabled;
        }
    }
}

export class Dropdown implements IDropdown {
    label?: string;
    name?: string;
    image?: string;
    options?: IDropdownOption[];
    className?: string;
    // isMultiSelect?: boolean;
    // msSelectedTextTemplate?: string;
    // msAllSelectedTextTemplate?: string;
    // msMinimumOneSelected?: boolean;
    // msSelectAllBtnText?: string;
    // msUnSelectAllBtnText?: string;
    // msShowToggleSelectionBtn?: boolean;

    constructor(dropdown?: IDropdown) {
        if (dropdown) {
            this.label = dropdown.label;
            this.name = dropdown.name;
            this.image = dropdown.image;
            this.options = dropdown.options;
            this.className = dropdown.className;
            // this.isMultiSelect = dropdown.isMultiSelect;
            // this.msSelectedTextTemplate = dropdown.msSelectedTextTemplate;
            // this.msAllSelectedTextTemplate = dropdown.msAllSelectedTextTemplate;
            // this.msMinimumOneSelected = dropdown.msMinimumOneSelected;
            // this.msSelectAllBtnText = dropdown.msSelectAllBtnText;
            // this.msUnSelectAllBtnText = dropdown.msUnSelectAllBtnText;
            // this.msShowToggleSelectionBtn = dropdown.msShowToggleSelectionBtn;
        } else {
            this.options = [];
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/multiselect-dropdown/multiselect-dropdown-model.ts